// Email address requirements:
// There must be one and only one '@' symbol.
// There must be at least one '.' to the right of the '@' symbol.
// There must be at least one alphanumeric character to the left of the '@' symbol.
// There must be at least one alphanumeric character to the right of the '@' symbol and to the left of the '.'
// There must be at least one alphanumeric character to the the right of the '.'

export default {
	data() {
		return {
			validationRulesEmail: [
				{
					message: "Must be in the following format: x@x.xx",
					regex: /^[^@]+@[^@]*\w[^@]*\.[^@]+$/
				}
			]
		};
	}
};
